import { z } from 'zod';

import { apiSchema } from './api/api.schema';
import { observabilitySchema } from './observability/observability.schema';
import { portalSchema } from './portal/portal.schema';

export const envSchema = apiSchema.and(observabilitySchema).and(portalSchema);

export type EnvConfig = z.infer<typeof envSchema>;
